import { z } from 'zod';
import {
  ExtendingComponentType,
  ComponentType,
} from '@wix/ambassador-devcenter-components-search-v1-components-search/types';

const importDataSchema = z.object({
  packageName: z.string(),
  subpathImport: z.string(),
  namedImport: z.string(),
  propsName: z.string(),
  propsNamespace: z.string(),
});

export type ImportData = z.infer<typeof importDataSchema>;

export const sdkSlotSchema = z.object({
  id: z.string(),
  appId: z.string(),
  wixDocsUrl: z.string(),
  importData: importDataSchema,
});

export const sdkSlotDataSchema = z.object({
  sdkSlotData: sdkSlotSchema,
});

export type SdkSlotData = z.infer<typeof sdkSlotDataSchema>;

export const backOfficeExtensionContainerSchema = z.object({
  component: z.object({
    type: z.literal(ComponentType.BACK_OFFICE_EXTENSION_CONTAINER),
    componentId: z.string().uuid(),
    name: z.string(),
    data: z.object({
      backOfficeExtensionContainer: z.object({
        extendable: z.object({
          extendedBy: z.enum([
            ExtendingComponentType.INVALID,
            ExtendingComponentType.BACK_OFFICE_EXTENSION_WIDGET,
            ExtendingComponentType.BACK_OFFICE_MENU_ITEM,
          ]),
        }),
        defaultRoute: z.string().nullable().optional(),
        slotData: z
          .object({
            displayName: z.string().nullable().optional(),
          })
          .optional(),
      }),
    }),
    externalId: z.string().nullable().optional(),
  }),
  appName: z.string(),
  appId: z.string().uuid(),
});

export type BackOfficeExtensionContainer = z.infer<
  typeof backOfficeExtensionContainerSchema
>;

export const backOfficePageSchema = z.object({
  component: z.object({
    type: z.literal(ComponentType.BACK_OFFICE_PAGE),
    componentId: z.string().uuid(),
    name: z.string(),
    data: z.object({
      backOfficePage: z.object({
        routePath: z.string(),
        metaData: z
          .object({
            title: z.string().nullable().optional(),
          })
          .optional(),
        slotIds: z.array(z.string()),
      }),
    }),
    externalId: z.string(),
  }),
  appName: z.string(),
  appId: z.string().uuid(),
});

export type BackOfficePage = z.infer<typeof backOfficePageSchema>;

const placementSchema = z.object({
  appDefinitionId: z.string(),
  widgetId: z.string(),
  slotId: z.string(),
});

export type Placement = z.infer<typeof placementSchema>;

export const widgetPluginSchema = z.object({
  component: z.object({
    componentId: z.string().uuid(),
    name: z.string(),
    data: z.object({
      widgetPlugin: z.object({
        placements: z.array(placementSchema),
      }),
    }),
    externalId: z.string().optional().nullable(),
  }),
  appName: z.string(),
  appId: z.string().uuid(),
});

export type WidgetPlugin = z.infer<typeof widgetPluginSchema>;
